import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  signal,
} from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'acl-success-modal',
  standalone: false,
  templateUrl: './success-modal.component.html',
  styleUrl: './success-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessModalComponent {
  private readonly modalController = inject(ModalController);
  readonly _title = signal<string>('');
  readonly _message = signal<string>('');

  @Input() set title(value: string) {
    this._title.set(value);
  }
  @Input() set message(value: string) {
    this._message.set(value);
  }

  dismissModal(): void {
    this.modalController.dismiss();
  }
}
